import { ARIAS, CLASSES } from '../utils/constants';

const initProductVideo = () => {
  const containers = document.querySelectorAll('[data-product-video]');
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.videoBound === 'true') return;
    container.dataset.videoBound = 'true';

    const video = container.querySelector('video');
    const toggle = container.querySelector('[data-product-video-toggle]');
    const muteBtn = container.querySelector('[data-product-video-mute]');
    const muteIconMuted = container.querySelector('[data-product-video-mute-icon-muted]');
    const muteIconUnmuted = container.querySelector('[data-product-video-mute-icon-unmuted]');
    if (!video || !toggle) return;

    const setPlayingState = (isPlaying) => {
      if (isPlaying) {
        toggle.setAttribute('data-playing', '');
        toggle.setAttribute(ARIAS.LABEL, 'Pause video');
      } else {
        toggle.removeAttribute('data-playing');
        toggle.setAttribute(ARIAS.LABEL, 'Play video');
      }
    };

    const setMutedState = (isMuted) => {
      if (!muteBtn) return;
      muteBtn.setAttribute(ARIAS.LABEL, isMuted ? 'Unmute video' : 'Mute video');
      muteIconMuted?.classList.toggle(CLASSES.HIDDEN, !isMuted);
      muteIconMuted?.classList.toggle(CLASSES.FLEX, isMuted);
      muteIconUnmuted?.classList.toggle(CLASSES.HIDDEN, isMuted);
      muteIconUnmuted?.classList.toggle(CLASSES.FLEX, !isMuted);
    };

    toggle.addEventListener('click', () => {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        video.muted = !video.muted;
      });
    }

    video.addEventListener('play', () => setPlayingState(true));
    video.addEventListener('pause', () => setPlayingState(false));
    video.addEventListener('ended', () => setPlayingState(false));
    video.addEventListener('volumechange', () => setMutedState(video.muted));

    setMutedState(video.muted);

    const slide = container.closest('.swiper-slide');
    if (slide) {
      const slideObserver = new MutationObserver(() => {
        if (!slide.classList.contains('swiper-slide-active') && !video.paused) {
          video.pause();
        }
      });
      slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
    }
  });
};

export default initProductVideo;
